module.exports = __webpack_public_path__ + "img/TRAKTOR.6df54162.svg";